module.exports = __webpack_public_path__ + "img/19.accd6db7.jpg";